import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { USER } from '../../../data/reducer';

const RadioButtonSelection = (props) => {
  const {
    notificationAgreement,
    setNotificationAgreement,
    moduleId,
    userInfo,
  } = props;

  return (
    <div className="ot-radio-button-container">
      <div className="control-group controls">
        <fieldset>
          <div className="radio-block">
            <label htmlFor={'agree'}>
              <input
                type="radio"
                name="notificationAgreement"
                value="agree"
                id="agree"
                checked={notificationAgreement === 'agree'}
                onChange={(event) => setNotificationAgreement(event)}
              />
              <span className="radio-check" />
              <span className="radio-label">
                <FormattedMessage
                  id={`${moduleId}.hpa.notifications.radioagree`}
                  values={{ name: userInfo.wholeName }}
                />
              </span>
            </label>
          </div>
          <div className="radio-block">
            <label htmlFor={'deny'}>
              <input
                type="radio"
                name="notificationAgreement"
                value={'deny'}
                id="deny"
                checked={notificationAgreement === 'deny'}
                onChange={(event) => setNotificationAgreement(event)}
              />
              <span className="radio-check" />
              <span className="radio-label">
                <FormattedMessage
                  id={`${moduleId}.hpa.notifications.radiodecline`}
                  values={{ name: userInfo.wholeName }}
                />
              </span>
            </label>
          </div>
        </fieldset>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userInfo: state[USER].userInfo.data,
  };
};

export default connect(mapStateToProps)(RadioButtonSelection);
